/* HUSHLY — transition de page au nuage.
   Elle ne se montre que si la page suivante tarde a venir : un voile qui
   clignote sur une navigation rapide fait paraitre le site plus lent, pas
   plus soigne. Pose le 2026-09-04. */
(function () {
  'use strict';
  /* 10/09 : Antonin trouve l attente trop longue. Le voile est desactive, le code reste
     en place et se rallume en repassant ACTIF a true. */
  var ACTIF = false;
  var SEUIL = 200;    // ms avant de montrer quoi que ce soit
  var SECOURS = 6000; // ms avant de se retirer tout seul si rien ne vient

  var veil = document.getElementById('hk-veil');
  if (!veil) return;
  if (!ACTIF) { veil.removeAttribute('data-on'); veil.setAttribute('aria-busy','false'); return; }

  var tMontre = null, tSecours = null;

  function montrer() {
    veil.setAttribute('data-on', '1');
    veil.setAttribute('aria-busy', 'true');
    tSecours = setTimeout(cacher, SECOURS);
  }
  function cacher() {
    clearTimeout(tMontre); clearTimeout(tSecours);
    veil.removeAttribute('data-on');
    veil.setAttribute('aria-busy', 'false');
  }
  function armer() {
    clearTimeout(tMontre);
    tMontre = setTimeout(montrer, SEUIL);
  }

  function interne(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.hasAttribute('data-no-veil')) return false;
    if (a.closest('[data-no-veil]')) return false;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return false; }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
    if (u.origin !== location.origin) return false;
    // ancre sur la meme page : aucune navigation
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
    // endpoints panier pilotes en ajax par le theme
    if (/^\/cart(\/|$)/.test(u.pathname) && a.closest('form')) return false;
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!interne(a)) return;
    armer();
  }, true);

  // soumission d un formulaire qui navigue vraiment
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.hasAttribute('data-no-veil')) return;
    if (f.getAttribute('target') && f.getAttribute('target') !== '_self') return;
    var act = f.getAttribute('action') || '';
    if (/^\/cart\/(add|change|update)/.test(act)) return; // ajax du panier
    armer();
  }, true);

  // retour arriere, cache bfcache, et chargement normal
  window.addEventListener('pageshow', cacher);
  window.addEventListener('popstate', cacher);
  window.addEventListener('hashchange', cacher);
  // si la navigation est annulee par l utilisateur
  window.addEventListener('pagehide', function () { clearTimeout(tSecours); });
})();
